import Vue from "vue";
import { SessionsService } from "@/common/api.service";
import {
  FETCH_SESSION,
  APPLICATION_GET_OR_CREATE,
  CRITERIA_FORM_GET,
  Innovations_FORM_GET,
  CRITERIA_FORM_SAVE_DRAFT,
  SESSION_RESET_STATE,
  Innovations_FORM_SAVE_DRAFT,
  checklist_GET,
  FETCH_APPLICATION,
  UPDATE_STATUS_APPLICATION,
  FETCH_APPLICATIONS,
  CHECK_APPLY_MULTIPLE_APPLICATION,
  CHECK_LABEL,
  STARTUP_INFORMATIONS_FORM_GET,
  STARTUP_INFORMATIONS_FORM_SAVE
} from "./actions.type";
import {
  RESET_STATE,
  SET_SESSION,
  SET_CRITERIA_FORM,
  SET_Innovations_FORM,
  SET_SidebarActive,
  SET_ERROR,
  PURGE_ERROR,
  SET_STARTUP_APPLICATION,
  REMOVE_SESSION,
  SET_APPLICATION,
  SET_ApplicationMenuActive,
  SET_LabelMenuActive,
  SET_HashId,
  SET_LabelApp,
  SET_SHOW_APP,
  SET_STARTUP_INFORMATIONS
} from "./mutations.type";
//import { FORMERR } from "dns";

const initialState = {
  session: {
    application_session: null,
    startup_application: null,
    user_auth: null
  },
  criteriaForm: {},
  innovationsForm: {},
  checklist: {},
  barActive: "0",
  ApplicationMenuActive: "1",
  LabelMenuActive: "0",
  LabelApplication: null,
  StartupInformations: null,
  hashId: null,
  errors: null,
  showApp: false
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_SESSION](context) {
    const { data } = await SessionsService.get();
    context.commit(SET_SESSION, data.data);
    return data;
  },
  async [FETCH_APPLICATION](context, id) {
    const { data } = await SessionsService.getCurrentApplication(id);
    context.commit(SET_SESSION, data.data);
    if(data.data.startup_application != null){
      context.commit(SET_LabelApp, data.data.startup_application.label_ref);
      context.commit(SET_HashId, data.data.startup_application.id);
      window.localStorage.setItem("hash_id", data.data.startup_application.id);
    }

    return data;
  },
  // Fetch list applications by user
  async [FETCH_APPLICATIONS](context) {
    const { data } = await SessionsService.getListApplications();
    //context.commit(SET_APPLICATION, data.data);
    //context.commit(SET_ApplicationMenuActive, 1);
    return data;
  },
  async [APPLICATION_GET_OR_CREATE](context, id) {
    const { data } = await SessionsService.getApplication(id);
    //context.commit(SET_SESSION, data.data);
    return data;
  },
  async [CRITERIA_FORM_GET](context, id) {
    const { data } = await SessionsService.criteriaFormGet(id);
    context.commit(SET_CRITERIA_FORM, data.data);
    return data;
  },
  async [Innovations_FORM_GET](context, id) {
    const { data } = await SessionsService.innovationsFormGet(id);
    context.commit(SET_Innovations_FORM, data.data);
    return data;
  },
  async [STARTUP_INFORMATIONS_FORM_GET](context, id) {
    const { data } = await SessionsService.startupInformationsFormGet(id);
    return data;
  },
  [STARTUP_INFORMATIONS_FORM_SAVE](context, form) {
    return new Promise((resolve, reject) => {
      SessionsService.startupInformationsFormSave(form.form.app_id, form.form.responses)
        .then(({ data }) => {
          if (data.meta.errors) context.commit(SET_ERROR, data.meta.errors);
          else context.commit(PURGE_ERROR);
          resolve(data);
        })
        .catch(({ response }) => {
          if (response != undefined)
            context.commit(SET_ERROR, response.data.meta.errors);
            reject(response);
        });
    });
  },
  async [checklist_GET](context, id) {
    const { data } = await SessionsService.checklistGet(id);
    context.commit(SET_STARTUP_APPLICATION, data.data.startup_application);
    return data;
  },
  [CRITERIA_FORM_SAVE_DRAFT](context, form) {
    return new Promise((resolve, reject) => {
      SessionsService.criteriaFormSaveDraft(form.id, form.responses)
        .then(({ data }) => {
          context.commit(SET_CRITERIA_FORM, data.data);
          if (data.meta.errors) context.commit(SET_ERROR, data.meta.errors);
          else context.commit(PURGE_ERROR);
          resolve(data);
        })
        .catch(({ response }) => {
          if (response != undefined)
            context.commit(SET_ERROR, response.data.meta.errors);
          reject(response);
        });
    });
  },
  [Innovations_FORM_SAVE_DRAFT](context, form) {
    return new Promise((resolve, reject) => {
      SessionsService.innovationsFormSaveDraft(form.id, form.responses)
        .then(({ data }) => {
          context.commit(SET_Innovations_FORM, data.data);
          if (data.meta.errors) context.commit(SET_ERROR, data.meta.errors);
          else context.commit(PURGE_ERROR);
          resolve(data);
        })
        .catch(({ response }) => {
          if (response != undefined)
            context.commit(SET_ERROR, response.data.meta.errors);
          reject(response);
        });
    });
  },
  async [UPDATE_STATUS_APPLICATION](context, applicationId) {
    const { data } = await SessionsService.updateStatusApplication(
      applicationId
    );
    context.commit(SET_STARTUP_APPLICATION, data.data);
    return data;
  },
  async [CHECK_APPLY_MULTIPLE_APPLICATION](context, userId) {
    const { data } = await SessionsService.checkApplyMultipleApplications(
      userId
    );
    return data;
  },

  [SESSION_RESET_STATE]({ commit }) {
    commit(RESET_STATE);
  },
  async [CHECK_LABEL](context, refApp){
    const { data } = await SessionsService.checkLabel(refApp)
    let label_ref = data.data.label_ref;
      if (label_ref) {
        context.commit(SET_LabelApp,label_ref);
      } else {
        context.commit(SET_LabelApp,null);
      }
    return data;
  }
};

export const mutations = {
  [SET_SESSION](state, session) {
    state.session = session;
  },
  [SET_SHOW_APP](state, showApp) {
    state.showApp = showApp;
  },
  [SET_APPLICATION](state, data) {
    state.session = data;
  },
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  },
  [SET_CRITERIA_FORM](state, data) {
    state.session.startup_application = data.startup_application;
    state.criteriaForm = data.form;
  },
  [SET_Innovations_FORM](state, data) {
    state.session.startup_application = data.startup_application;
    state.innovationsForm = data.form;
  },
  [SET_STARTUP_APPLICATION](state, startup_application) {
    state.session.startup_application = startup_application;
  },
  [SET_SidebarActive](state, data) {
    state.barActive = data;
  },
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [PURGE_ERROR](state) {
    state.errors = null;
  },
  [REMOVE_SESSION](state) {
    state.session.startup_application = null;
    state.criteriaForm = {};
    state.innovationsForm = {};
  },
  [SET_ApplicationMenuActive](state, data) {
    state.ApplicationMenuActive = data;
  },
  [SET_LabelMenuActive](state, data) {
    state.LabelMenuActive = data;
  },
  [SET_HashId](state, data) {
    state.hashId = data;
  },
  [SET_LabelApp](state, data) {
    state.LabelApplication = data;
  },
  [SET_STARTUP_INFORMATIONS](state, data) {
    state.StartupInformations = data;
  }
};

const getters = {
  session(state) {
    return state.session;
  },
  showApp(state) {
    return state.showApp;
  },
  startup_application(state) {
    return state.session.startup_application;
  },
  criteriaForm(state) {
    return state.criteriaForm;
  },
  innovationsForm(state) {
    return state.innovationsForm;
  },
  checklist(state) {
    return state.checklist;
  },
  barActive(state) {
    return state.barActive;
  },
  ApplicationMenuActive(state) {
    return state.ApplicationMenuActive;
  },
  LabelMenuActive(state) {
    return state.LabelMenuActive;
  },
  hashId(state) {
    return state.hashId;
  },
  LabelApplication(state) {
    return state.LabelApplication;
  },
  StartupInformations(state) {
    return state.StartupInformations;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
